import { Field, Int, ObjectType } from '@nestjs/graphql'

@ObjectType()
export class UserEmailDto {
  @Field(t => Int)
  id!: number

  @Field()
  emailAddress!: string

  @Field(t => Int)
  status!: number

  @Field()
  isDefault!: boolean

  @Field(type => String, { nullable: true })
  postmarkBounceCode?: string

  @Field(type => String, { nullable: true })
  postmarkBounceName?: string

  @Field(type => String, { nullable: true })
  postmarkBounceDescription?: string

  @Field({ nullable: true })
  postmarkBounceDate?: Date

  @Field(t => Int)
  postmarkBounceCount!: number

  public constructor (partial?: Partial<UserEmailDto>) {
    Object.assign(this, partial)
  }
}
